import { useCallback, useState } from 'react';

export type SortDirection = 'asc' | 'desc' | 'none';

export type SortState = {
    sortedByField: string;
    direction: SortDirection;
};

export const useTableSort = (initial: SortState) => {
    const [sort, setSort] = useState<SortState>(initial);

    const sortBy = useCallback((sortedByField: string, direction: SortDirection) => {
        setSort({ sortedByField, direction });
    }, []);

    return { sort, sortBy };
};

export const toMuiSortOrder = (sort: SortState) =>
    sort.direction === 'none' ? undefined : { name: sort.sortedByField, direction: sort.direction };
